// extracted by mini-css-extract-plugin
module.exports = {"InputForm":"CompanySettingEditModal_InputForm__1P6NC"};